import { render, staticRenderFns } from "./indication.vue?vue&type=template&id=3935e891"
import script from "./indication.vue?vue&type=script&lang=js"
export * from "./indication.vue?vue&type=script&lang=js"
import style0 from "./indication.vue?vue&type=style&index=0&id=3935e891&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports